import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Restoration"
});
const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M17.6028 1.62925L17.6028 4.10114H18.5546C19.2647 4.10114 19.5003 4.54788 19.0726 5.10788L16.7676 8.12811C16.3431 8.68433 15.6587 8.68811 15.231 8.12811L12.9253 5.10788C12.5015 4.55166 12.7352 4.10114 13.444 4.10114H14.3957V1.62925C14.3957 1.54608 14.4125 1.46375 14.4451 1.38699C14.4777 1.31024 14.5254 1.2406 14.5855 1.18208C14.6457 1.12357 14.717 1.07736 14.7954 1.04611C14.8739 1.01486 14.9578 0.9992 15.0424 1.00003H16.9562C17.3134 1.00003 17.6028 1.28003 17.6028 1.62925Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M14.9003 9.71836L12.0055 6.14634C11.7362 5.9968 11.4462 5.89377 11.1484 5.83711L11.8449 11.7147C11.8986 12.1678 12.3205 12.4801 12.764 12.3952L15.2917 11.911C15.6058 11.8489 15.935 11.969 16.1282 12.2171L17.6841 14.2071C17.9417 14.5365 18.4094 14.6039 18.7478 14.3604L20.4217 13.1558C20.5109 13.0915 20.5693 12.9923 20.5825 12.8824L21.4371 5.78534C20.9364 5.77992 20.4342 5.90135 19.9889 6.15026L17.0979 9.71836C16.4908 10.5318 15.512 10.5373 14.9003 9.71836Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  d: "M12.2659 14.0976L15.1178 13.5513L16.8295 15.7406C17.091 16.075 17.4802 16.2961 17.9116 16.3552C18.343 16.4143 18.7812 16.3065 19.1298 16.0557L21.5477 14.3155C21.8855 14.0724 22.1128 13.7137 22.1822 13.3141L23.0189 6.26737C24.2863 7.03751 25.8941 8.28618 26.4277 9.89003C26.4711 10.0202 26.5155 10.1521 26.5603 10.2851C27.4736 12.9951 28.5807 16.2801 25.2713 19.953C25.2713 19.953 27.1226 27.2333 22.725 30.6588C22.725 30.6588 19.5149 31.9964 19.948 29.3739C20.2304 27.6715 20.2098 21.3614 15.9999 21.0531C11.7909 21.3614 11.7702 27.6707 12.0518 29.3739C12.4858 31.9964 9.27388 30.6588 9.27388 30.6588C4.87799 27.2333 6.72848 19.953 6.72848 19.953C3.41955 16.2789 4.52649 12.9942 5.43979 10.2841C5.48452 10.1513 5.52878 10.02 5.57204 9.89003C6.12572 8.22588 7.83585 6.94411 9.12405 6.18254C9.24819 6.1093 9.37715 6.04617 9.50962 5.99316L10.3246 12.8168C10.3991 13.2365 10.6474 13.6094 11.0131 13.8507C11.3788 14.0919 11.8306 14.181 12.2659 14.0976Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
var Restoration = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { Restoration as default };
